import { render, staticRenderFns } from "./PotentialClient.vue?vue&type=template&id=2ccebccc&"
import script from "./PotentialClient.vue?vue&type=script&lang=js&"
export * from "./PotentialClient.vue?vue&type=script&lang=js&"
import style0 from "./PotentialClient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PotentialClient.vue"
export default component.exports